module.exports = __webpack_public_path__ + "static/img/bg-vip0.b91ab0ef.png";